import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, pdf, Font } from '@react-pdf/renderer';
import { FiPrinter } from 'react-icons/fi';

import logo from '../../../assets/Ativo 2.png';
import checked from '../../../assets/icons/marcado.png';
import unchecked from '../../../assets/icons/não-marcado.png';

Font.register({
  family: 'MontserratMedium',
  fonts: [
    {
      src: '/fonts/Montserrat_Medium.ttf',
      fontWeight: '500',
    },
  ],
});

Font.register({
  family: 'MontserratBold',
  fonts: [
    {
      src: '/fonts/Montserrat_Bold.ttf',
      fontWeight: '700',
    },
  ],
});

Font.register({
  family: 'MontserratBlack',
  fonts: [
    {
      src: '/fonts/Montserrat_Black.ttf',
      fontWeight: '900',
    },
  ],
});
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: 'MontserratMedium',
    fontWeight: 500,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 20,
  },
  logo: {
    width: 150,
  },
  icone: {
    width: 12,
  },
  title: {
    fontFamily: 'MontserratBold',
    fontSize: 18,
    fontWeight: 900,
    marginBottom: 10,
  },
  section: {
    marginTop: 20,
    marginBottom: 10,
    lineHeight: 1.5,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    fontFamily: 'MontserratMedium',
    fontSize: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  bold: {
    fontFamily: 'MontserratBold',
    fontWeight: 600,
  },
  bold2: {
    fontFamily: 'MontserratBold',
    fontWeight: 600,
    marginTop: '5px',
    lineHeight: '11px'
  },
  linha: {
    marginTop: '5px'
  },
  linha2: {
    marginTop: '5px',
    lineHeight: '11px'
  },
  espaco: {
    marginTop: '5px',
    marginRight: '7px'
  },
  assinatura: {
    marginTop: '65px',
  }
});

const RelatorioPDF = ({ dados }) => {
  console.log("Dados recebidos para PDF:", dados);

  const dataHora = new Date(dados.data_hora_acidente);

  // Data formatada: dd/mm/yyyy
  const dataAcidenteFormatada = dataHora.toLocaleDateString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
  });

  // Hora formatada: hh:mm
  const horaAcidenteFormatada = dataHora.toLocaleTimeString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
  });

  const CheckboxLinha = ({ texto, valor }) => {
    const imagem = (valor === '1' || valor === 1)
      ? checked
      : unchecked;

    return (
      <View style={{ marginTop: 5, flexDirection: 'row', alignItems: 'center' }}>
        <Image
          src={imagem}
          style={{ width: 11, height: 11, marginRight: 6 }}
        />
        <Text style={{lineHeight: '11px'}} >{texto}</Text>
      </View>
    );
  };

  const CheckboxLinhaInverso = ({ texto, valor }) => {
    const imagem = (valor === '0' || valor === '' || valor === 0)
      ? checked
      : unchecked;

    return (
      <View style={{ marginTop: 5, flexDirection: 'row', alignItems: 'center' }}>
        <Image
          src={imagem}
          style={{ width: 11, height: 11, marginRight: 6 }}
        />
        <Text style={{lineHeight: '11px'}} >{texto}</Text>
      </View>
    );
  };

  const CheckboxLinhaAlvo = ({ texto, valor, alvo }) => {
    const imagem = valor === alvo
      ? checked
      : unchecked;

    return (
      <View style={{ marginTop: 5, flexDirection: 'row', alignItems: 'center' }}>
        <Image
          src={imagem}
          style={{ width: 11, height: 11, marginRight: 6 }}
        />
        <Text style={{lineHeight: '11px'}} >{texto}</Text>
      </View>
    );
  };

  const Acoes = ({ valor }) => {
    const acoes = JSON.parse(valor || '[]');

    return (
      <View>
        {acoes.map((acao, index) => (
          <View key={index} style={{ marginTop: 8, marginBottom: 12 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
              <Text style={styles.bold2}>Ação / Medida:</Text>
              <Text style={styles.espaco}></Text>
              <Text style={styles.linha2}>{acao.acao}</Text>
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
              <Text style={styles.bold2}>Tipo:</Text>
              <Text style={styles.espaco}></Text>
              <CheckboxLinhaAlvo style={styles.linha2} texto="Corretiva" valor={acao.tipo} alvo={"Corretiva"} />
              <Text style={styles.espaco}></Text>
              <CheckboxLinhaAlvo style={styles.linha2} texto="Preventiva" valor={acao.tipo} alvo={"Preventiva"} />
            </View>
            
            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
              <Text style={styles.bold2}>Responsável:</Text>
              <Text style={styles.espaco}></Text>
              <Text style={styles.linha2}>{acao.responsavel}</Text>
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
              <Text style={styles.bold2}>Prazo de Execução:</Text>
              <Text style={styles.espaco}></Text>
              <Text style={styles.linha2}>{(new Date(acao.prazo)).toLocaleDateString('pt-BR', {timeZone: 'America/Sao_Paulo',}) || '-'}</Text>
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
              <Text style={styles.bold2}>Status:</Text>
              <Text style={styles.espaco}></Text>
              <CheckboxLinhaAlvo style={styles.linha2} texto="Pendente" valor={acao.status} alvo={"Pendente"} />
              <Text style={styles.espaco}></Text>
              <CheckboxLinhaAlvo style={styles.linha2} texto="Em andamento" valor={acao.status} alvo={"Em andamento"} />
              <Text style={styles.espaco}></Text>
              <CheckboxLinhaAlvo style={styles.linha2} texto="Concluído" valor={acao.status} alvo={"Concluído"} />
            </View>
          </View>
        ))}
      </View>
    );
  };

  return (
    <Document>
    <Page size="A4" style={styles.page}>
      {/* Cabeçalho */}
      <View style={styles.header}>
        <Image style={styles.logo} src={logo} />
      </View>

      {/* Título */}
      <Text style={styles.title}>RELATÓRIO DE ANÁLISE DE ACIDENTE</Text>

      <Text>
        <Text style={styles.bold}>Versão: </Text>
        <Text>2022.1</Text>
      </Text>
      
      <Text style={styles.linha}>
        <Text style={styles.bold}>Setor Responsável: </Text>
        <Text>HSEQ - Departamento de Saúde, Segurança, Meio Ambiente e Qualidade</Text>
      </Text>
      

      {/* Corpo do relatório */}
      <View style={styles.section}>
        <Text>
          <Text style={styles.bold}>Responsável pelo preenchimento: </Text>
          <Text>{dados.nome_responsavel_registro}</Text>
        </Text>
        
        <Text style={styles.linha}>
          <Text style={styles.bold}>Supervisor na ocasião do acidente: </Text>
          <Text>{dados.nome_supervisor_acidente}</Text>
        </Text>

        <Text style={styles.linha}>
          <Text style={styles.bold}>Data da ocorrência: </Text>
          <Text>{dataAcidenteFormatada}</Text>
        </Text>

        <Text style={styles.linha}>
          <Text style={styles.bold}>Hora da ocorrência: </Text>
          <Text>{horaAcidenteFormatada}</Text>
        </Text>

        <Text style={styles.linha}>
          <Text style={styles.bold}>Local: </Text>
          <Text>{dados.local_acidente_resumido}</Text>
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.bold}>1. Dados da vítima</Text>

        <Text style={styles.linha}>Nome: {dados.nome_vitima}</Text>
        
        <Text style={styles.linha}>Tipo de vínculo: {dados.vinculo_colaborador_acidente}</Text>

        <Text style={styles.linha}>Setor: {dados.setor_colaborador_acidente}</Text>

        <Text style={styles.linha}>Função na ocasião do acidente: {dados.funcao_colaborador_acidente}</Text>

        <Text style={styles.linha}>Tempo na função: {dados.meses_colaborador_funcao_acidente} meses</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.bold}>2. Testemunhas</Text>

        <Text style={styles.linha}>{dados.testemunha_acidente}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.bold}>3. Local do Acidente</Text>

        <Text style={styles.linha}>Descrição: {dados.descricao_local_acidente}</Text>
        
        <Text style={styles.linha}>Endereço: {dados.endereco_local_acidente}</Text>
      </View>







      <View break>
        <View style={styles.section}>
          <Text style={styles.bold}>4. Consequência do acidente</Text>

          <CheckboxLinha style={styles.linha} texto="Apenas primeiros socorros" valor={dados.apenas_pimeiros_socorros} />
          <CheckboxLinha style={styles.linha} texto="Afastamento até 3 dias" valor={dados.afastamento_ate_3} />
          <CheckboxLinha style={styles.linha} texto="Afastamento entre 4 e 30 dias" valor={dados.afastamento_entre_4_e_30} />
          <CheckboxLinha style={styles.linha} texto="Afastamento maior que 30 dias" valor={dados.afastamento_maior_30} />
          <CheckboxLinha style={styles.linha} texto="Óbito" valor={dados.obito} />

        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>5. Tipo de Acidente: (Marque todas as opções que se aplicam)</Text>
          <Text style={styles.bold}>Risco elétrico</Text>

          <CheckboxLinha style={styles.linha} texto="Choque elétrico (baixa tensão)" valor={dados.choque_eletrico_baixa_tensao} />
          <CheckboxLinha style={styles.linha} texto="Choque elétrico (alta tensão)" valor={dados.choque_eletrico_alta_tensao} />
          <CheckboxLinha style={styles.linha} texto="Arco elétrico" valor={dados.arco_eletrico} />
          <CheckboxLinha style={styles.linha} texto="Explosão de painel elétrico" valor={dados.explosao_painel_eletrico} />
        </View>
        <View style={styles.section}>
  
          <Text style={styles.bold}>Risco Físico e Mecânico</Text>

          <CheckboxLinha style={styles.linha} texto="Queda em mesma altura" valor={dados.queda_mesma_altura} />
          <CheckboxLinha style={styles.linha} texto="Queda de altura (telhado, escada, estrutura metálica)" valor={dados.queda_altura_elevada} />
          <CheckboxLinha style={styles.linha} texto="Escorregão ou tropeço" valor={dados.escorregao_ou_tropeco} />
          <CheckboxLinha style={styles.linha} texto="Impacto com objeto móvel" valor={dados.impacto_objeto_movel} />
          <CheckboxLinha style={styles.linha} texto="Colisão com veículo ou máquina" valor={dados.colisao_veiculo_ou_maquina} />
          <CheckboxLinha style={styles.linha} texto="Prensamento entre objetos" valor={dados.prensamento} />
          <CheckboxLinha style={styles.linha} texto="Corte ou laceração (manual ou com ferramenta)" valor={dados.corte_ou_laceracao} />
          <CheckboxLinha style={styles.linha} texto="Perfuração ou perfuração por objeto pontiagudo" valor={dados.perfuracao} />
          <CheckboxLinha style={styles.linha} texto="Esmagamento" valor={dados.esmagamento} />
          <CheckboxLinha style={styles.linha} texto="Entorse ou luxação" valor={dados.entorse_ou_luxacao} />
          <CheckboxLinha style={styles.linha} texto="Fratura" valor={dados.fratura} />
          
        </View>
        <View style={styles.section}>
  
          <Text style={styles.bold}>Incêndios e Queimaduras</Text>
          <CheckboxLinha style={styles.linha} texto="Queimadura térmica (fogo, vapor, superfície quente)" valor={dados.queimadura_termica} />
          <CheckboxLinha style={styles.linha} texto="Queimadura química" valor={dados.queimadura_quimica} />
          <CheckboxLinha style={styles.linha} texto="Incêndio / Princípio de incêndio" valor={dados.incendio_ou_principio} />
          <CheckboxLinha style={styles.linha} texto="Inalação de fumaça ou gases tóxicos" valor={dados.inalacao} />
          
        </View>
      </View>

      <View break>
        <View style={styles.section}>
          <Text style={styles.bold}>Exposição a Substâncias Perigosas</Text>
          <CheckboxLinha style={styles.linha} texto="Contato com produto químico" valor={dados.contato_produto_quimico} />
          <CheckboxLinha style={styles.linha} texto="Vazamento de gás ou fluido" valor={dados.vazamento} />
          <CheckboxLinha style={styles.linha} texto="Intoxicação por substância" valor={dados.intoxicacao} />
        </View>
        <View style={styles.section}>
          <Text style={styles.bold}>Fatores Ambientais / Naturais</Text>
          <CheckboxLinha style={styles.linha} texto="Mordida ou picada (insetos, aranhas, cobras etc.)" valor={dados.mordida_ou_picada} />
          <CheckboxLinha style={styles.linha} texto="Alagamento / vendaval / deslizamento" valor={dados.alagamento_vendaval_deslizamento} />
        </View>
        <View style={styles.section}>
          <Text style={styles.bold}>Outros Acidentes ou Situações</Text>
          <CheckboxLinha style={styles.linha} texto="Falha de equipamento / ferramenta" valor={dados.falha_equipamento_maquina} />
          <CheckboxLinha style={styles.linha} texto="Falha de andaime / plataforma" valor={dados.falha_andaime_plataforma} />
          <CheckboxLinha style={styles.linha} texto="Deficiência de iluminação / visibilidade" valor={dados.deficiencia_iluminacao} />
          <CheckboxLinha style={styles.linha} texto="Atos de violência" valor={dados.violencia} />
          <CheckboxLinha style={styles.linha} texto="Acidente em deslocamento (trajeto interno/externo)" valor={dados.deslocamento} />
        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>6. Atendimento médico</Text>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Text style={styles.linha2}>Houve atendimento médico? </Text>
            <Text style={styles.espaco}></Text>
            <CheckboxLinha style={styles.linha2} texto="Sim" valor={dados.atendimento_medico} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaInverso style={styles.linha2} texto="Não" valor={dados.atendimento_medico} />
          </View>

          <Text style={styles.linha}>Local: {dados.local_atendimento_medico}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>7. Descrição do acidente</Text>
          <Text style={styles.linha}>Informe de forma detalhada o que ocorreu:</Text>
          <Text style={styles.linha}>{dados.descricao_acidente}</Text>
        </View>

      </View>

      
      <View break>
        <View style={styles.section}>
          <Text style={styles.bold}>8. Condições Ambientais no Momento:</Text>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Text style={styles.linha2}>Iluminação:</Text>
            <Text style={styles.espaco}></Text>
            <CheckboxLinha style={styles.linha2} texto="Boa" valor={dados.iluminacao_boa} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaInverso style={styles.linha2} texto="Ruim" valor={dados.iluminacao_boa} />
          </View>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Text style={styles.linha2}>Clima:</Text>
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaAlvo style={styles.linha2} texto="Sol" valor={dados.clima} alvo={"Sol"} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaAlvo style={styles.linha2} texto="Chuva" valor={dados.clima} alvo={"Chuva"} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaAlvo style={styles.linha2} texto="Nublado" valor={dados.clima} alvo={"Nublado"} />
          </View>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Text style={styles.linha2}>Piso:</Text>
            <Text style={styles.espaco}></Text>
            <CheckboxLinha style={styles.linha2} texto="Seco" valor={dados.piso_seco} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaInverso style={styles.linha2} texto="Escorregadio" valor={dados.piso_seco} />
          </View>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <Text style={styles.linha2}>Presença de riscos próximos?</Text>
            <Text style={styles.espaco}></Text>
            <CheckboxLinha style={styles.linha2} texto="Sim" valor={dados.presenca_outros_riscos} />
            <Text style={styles.espaco}></Text>
            <CheckboxLinhaInverso style={styles.linha2} texto="Não" valor={dados.presenca_outros_riscos} />
          </View>
          <Text style={{...styles.linha2, marginLeft: "10px"}}>Caso sim, quais? {dados.outros_riscos}</Text>


          <View style={styles.section}>
            <Text style={styles.bold}>9. Uso de EPI:</Text>
            <Text style={styles.bold}>Listar equipamentos presentes:</Text>
            <Text style={styles.linha}>{dados.epi_presente}</Text>
            <Text style={styles.linha}></Text>

            <Text style={styles.bold}>Listar equipamentos ausentes:</Text>
            <Text style={styles.linha}>{dados.epi_ausente}</Text>
            <Text style={styles.linha}></Text>

            <Text style={styles.bold}>Observações:</Text>
            <Text style={styles.linha}>{dados.epi_observacoes}</Text>
            <Text style={styles.linha}></Text>
          </View>
  
        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>10. Causas do acidente:</Text>
          <Text style={styles.linha}>1. Comportamento / Falha Humana</Text>
          <CheckboxLinha style={styles.linha} texto="Ato inseguro do trabalhador" valor={dados.ato_inseguro_trabalhador} />
          <CheckboxLinha style={styles.linha} texto="Desatenção ou distração" valor={dados.desatencao_distracao} />
          <CheckboxLinha style={styles.linha} texto="Pressa ou comportamento apressado" valor={dados.pressa} />
          <CheckboxLinha style={styles.linha} texto="Excesso de confiança" valor={dados.excesso_confianca} />
          <CheckboxLinha style={styles.linha} texto="Falta de capacitação ou treinamento" valor={dados.falta_treinamento} />
          <CheckboxLinha style={styles.linha} texto="Uso inadequado de ferramentas ou equipamentos" valor={dados.uso_inadequado_ferramentas} />
          <CheckboxLinha style={styles.linha} texto="Improvisação" valor={dados.improvisacao} />
          <CheckboxLinha style={styles.linha} texto="Fadiga física ou mental" valor={dados.fadiga} />
          <CheckboxLinha style={styles.linha} texto="Negligência ou descumprimento de procedimentos" valor={dados.negligencia_procedimentos} />
        </View>
        <View style={styles.section}>
          <Text style={styles.linha}>2. Equipamentos / Ferramentas / Engenharia</Text>
          <CheckboxLinha style={styles.linha} texto="Falha de equipamento ou ferramenta" valor={dados.falha_equipamento} />
          <CheckboxLinha style={styles.linha} texto="Falta de manutenção preventiva" valor={dados.falta_manutencao_preventiva} />
          <CheckboxLinha style={styles.linha} texto="Equipamento com defeito conhecido" valor={dados.equipamento_defeito_conhecido} />
          <CheckboxLinha style={styles.linha} texto="Utilização de equipamento/ferramenta inadequado para a tarefa" valor={dados.equipamento_inadequado} />
          <CheckboxLinha style={styles.linha} texto="Ausência de dispositivos de proteção (ex: proteção de correia, botão de emergência)" valor={dados.ausencia_dispositivo_protecao} />
          <CheckboxLinha style={styles.linha} texto="Projeto inadequado de máquina, processo ou instalação" valor={dados.projeto_inadequado} />
        </View>
      </View>

      <View break>
        <View style={styles.section}>
          <Text style={styles.linha}>3. Ambiente de Trabalho</Text>
          <CheckboxLinha style={styles.linha} texto="Iluminação inadequada" valor={dados.iluminacao_inadequada} />
          <CheckboxLinha style={styles.linha} texto="Ruído excessivo" valor={dados.ruido_excessivo} />
          <CheckboxLinha style={styles.linha} texto="Temperatura extrema" valor={dados.temperatura_extrema} />
          <CheckboxLinha style={styles.linha} texto="Piso escorregadio ou irregular" valor={dados.piso_inseguro} />
          <CheckboxLinha style={styles.linha} texto="Obstrução em rotas de fuga ou circulação" valor={dados.obstrucao_rotas} />
          <CheckboxLinha style={styles.linha} texto="Sinalização inadequada" valor={dados.sinalizacao_inadequada} />
        </View>
        <View style={styles.section}>
          <Text style={styles.linha}>4. Uso ou Ausência de EPIs</Text>
          <CheckboxLinha style={styles.linha} texto="Não uso de EPI necessário" valor={dados.nao_uso_epi} />
          <CheckboxLinha style={styles.linha} texto="Uso incorreto de EPI" valor={dados.uso_incorreto_epi} />
          <CheckboxLinha style={styles.linha} texto="EPI danificado ou ineficaz" valor={dados.epi_danificado_ou_ineficaz} />
          <CheckboxLinha style={styles.linha} texto="Falta de fornecimento de EPI adequado" valor={dados.falta_epi} />
        </View>
        <View style={styles.section}>
          <Text style={styles.linha}>5. Processos e Organização</Text>
          <CheckboxLinha style={styles.linha} texto="Instruções de trabalho inadequadas ou inexistentes" valor={dados.intrucao_inadeqada} />
          <CheckboxLinha style={styles.linha} texto="Falta de planejamento ou análise de risco da tarefa" valor={dados.falta_planejamento} />
          <CheckboxLinha style={styles.linha} texto="Mudança de tarefa sem reavaliação dos riscos" valor={dados.mudanca_tarefa} />
          <CheckboxLinha style={styles.linha} texto="Falha na comunicação entre equipe" valor={dados.falha_comunicacao} />
          <CheckboxLinha style={styles.linha} texto="Supervisão insuficiente" valor={dados.supervisao_ineficiente} />
          <CheckboxLinha style={styles.linha} texto="Ausência de procedimentos operacionais definidos" valor={dados.ausencia_procedimento} />
        </View>
        <View style={styles.section}>
          <Text style={styles.linha}>6. Fatores Externos</Text>
          <CheckboxLinha style={styles.linha} texto="Interferência de terceiros (visitantes, fornecedores etc.)" valor={dados.interferencia_terceiros} />
          <CheckboxLinha style={styles.linha} texto="Fatores climáticos adversos (chuva, vento, calor)" valor={dados.fatores_climaticos} />
          <CheckboxLinha style={styles.linha} texto="Evento externo não previsto (queda de energia, interrupção de rede etc.)" valor={dados.evento_externo_nao_previsto} />
        </View>
        <View style={styles.section}>
          <Text style={styles.linha}>7. Outros</Text>

          <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
            <CheckboxLinha style={styles.linha} texto="Outro:" valor={dados.outra_causa_acidente} />
            <Text style={styles.espaco}></Text>
            <Text>{dados.descricao_outra_causa_acidente}</Text>
          </View>
        </View>
      </View>

      <View break>

        <View style={styles.section}>
          <Text style={styles.bold}>11. Ações corretivas e preventivas</Text>
          <Text style={styles.linha}>Listar todas as ações corretivas:</Text>

          <Acoes style={styles.linha} valor={dados.acoes_corretivas_preventivas} />
        </View>
      </View>

      <View break>

        <View style={styles.section}>
          <Text style={styles.bold}>12. Observações finais / Lições aprendidas:</Text>
          <Text style={styles.linha}>{dados.observacoes_finais_licoes_aprendidas}</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>Assinatura:</Text>
          <Text style={{...styles.bold, ...styles.assinatura}}>{dados.nome_responsavel_registro}</Text>
          <Text style={styles.linha}>{dados.funcao_responsavel_registro}</Text>
          <Text style={styles.linha}>{dados.setor_responsavel_registro}</Text>
        </View>
      </View>




      {/* Rodapé */}
      <View style={styles.footer} fixed>
        <Text>
          <Text style={styles.bold}>HSEQ</Text>
          <Text> | Relatório de Análise de Acidente 2022.1</Text>
        </Text>

        <Text
          fixed
          render={({ pageNumber, totalPages }) =>
            `Página ${pageNumber} de ${totalPages}`
          }
        />

      </View>
    </Page>
    </Document>
  )
};

const BotaoImprimir = ({ dados }) => {
  const gerarPDF = async () => {
    try {
      const blob = await pdf(<RelatorioPDF dados={dados} />).toBlob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'relatorio-acidente.pdf';
      link.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erro ao gerar PDF:', err);
    }
  };

  const abrirPdfNovaAba = async () => {
    const blob = await pdf(<RelatorioPDF dados={dados} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };


  return (
    <button className='print1' type="button" onClick={(e) => {e.preventDefault(); abrirPdfNovaAba();}}>
      <FiPrinter size={18} />
    </button>
  );
};



export { RelatorioPDF, BotaoImprimir };

